export default "__VITE_ASSET__DPsaxZd5__"